import { useApi } from 'api'
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AxiosError } from 'openapi-client-axios'
import { useState } from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { Invoice } from 'types'

export default function DeleteButton({
  invoice,
  onDelete,
}: {
  invoice: Invoice
  onDelete?: Function
}) {
  const [showModal, setShowModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const api = useApi()
  const deleteInvoice = async () => {
    try {
      await api.deleteInvoice(invoice)
      onDelete && (await onDelete(invoice))
      setShowModal(false)
    } catch (e: any) {
      const err = e as AxiosError<any>
      setErrorMessage(
        (err.response?.data?.message as string) ||
          `An error occured: ${err.response?.status} - ${err.response?.statusText}`
      )
    }
  }
  const handleClose = () => {
    setShowModal(false)
    setErrorMessage(undefined)
  }
  const handleShow = () => setShowModal(true)

  return (
    <>
      <Button onClick={handleShow} variant="outline-danger">
        <FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
        &nbsp;Delete
      </Button>
      <Modal show={showModal}>
        <Modal.Header>
          <Modal.Title>Delete the invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you really want to delete the invoice "#{invoice.id}"?
          <Alert variant="danger" hidden={!errorMessage}>
            <b>Unable to delete the invoice: </b>
            <blockquote>{errorMessage}</blockquote>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" aria-label="Close" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            aria-label="delete invoice"
            onClick={deleteInvoice}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
